const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfGovernment extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfGovernment,
            "Each civilization scores 2 culture per civil action and 1 culture per military action.",
            {}
        )
    }
}

module.exports = ImpactOfGovernment;